import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { get, set } from '@submize/lodash';
import { produce } from 'immer';
import useDebounce from '../../helpers/useDebounce';
import { setField } from '../FormEditor/Editor/editorSlice';

const useUpdateField = (field, path, initialValue = '') => {
  const [state, setState] = useState(initialValue);
  const dispatch = useDispatch();

  const debouncedRequest = useDebounce(() => {
    const obj = produce(field, (draft) => {
      set(draft, path, state);
    });
    dispatch(setField({
      key: field.key,
      field: obj,
    }));
  });

  const onChange = (value) => {
    setState(value);
    debouncedRequest();
  };

  useEffect(() => {
    if (field) {
      setState(get(field, path, initialValue));
    }
  }, [field?.key]);

  return [state, onChange];
};

export default useUpdateField;
